import { Injectable } from '@angular/core';
import { environment } from '../../environments/environment';

@Injectable({
  providedIn: 'root',
})
export class EnvironmentService {
  private envConfig = environment;

  constructor() {}

  getEnvConfig() {
    return this.envConfig;
  }
}
